import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">404: La página que buscas no existe</Typography>
            <Typography variant="subtitle2">Tocá la imagen para volver</Typography>
            <a href="/dashboard">
              <img alt="Pagina no encontrada" className={classes.image} src="/images/draws/page_not_found.svg" />
            </a>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
